/**
 * Created by mac90082 on 10/26/16.
 */
import { Component, Inject } from "@angular/core";
import { Tools } from "@app/util/tools";

@Component({
    selector: 'app-moo-bank',
    template: require('./moobank.html')
})
export class MooBankComponent {
    constructor(@Inject(Tools) public tools: any) {
    }
}


